export default "__VITE_ASSET__DD25jq2R__ 640w, __VITE_ASSET__BTvpvfGL__ 1024w";